import jwtDecode from "jwt-decode";

function getAuthToken() {
  const token = localStorage.authToken;
  try {
    jwtDecode(token);
    return token;
  }
  catch(e) {
    // nothing
  }
}

const initialState = (token => ({
  isAuthenticating: false,
  errorMessage: null,
  id: token ? jwtDecode(token).id : null,
  currentUser: token ? jwtDecode(token).id : null,
  email: token ? jwtDecode(token).email : null,
  type: token ? jwtDecode(token).type : null,
  name: token ? jwtDecode(token).name : null,
  token: token || null
}))(getAuthToken());

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case "LOGIN_REQUEST":
      return {
        ...state,
        isAuthenticating: true
      };
    case "LOGIN_FAILURE":
      return {
        ...state,
        isAuthenticating: false,
        errorMessage: action.errorMessage
      };
    case "LOGIN_SUCCESS":
      return {
        isAuthenticating: false,
        currentUser: action.user.id,
        email: action.user.email,
        errorMessage: null,
        type: action.user.type,
        id: action.user.id,
        name: action.user.name,
        token: action.token
      };
    case "LOGOUT":
      localStorage.removeItem("authToken");
      return {
        isAuthenticating: false,
        currentUser: null,
        email: null,
        errorMessage: null,
        type: null,
        name: null,
        token: null
      };
    default:
      return state;
  }
};
export default reducer;
